module.exports = __webpack_public_path__ + "img/arrow-left.3b788472.svg";